import React from 'react';
import { Helmet } from 'react-helmet';
import { Box, Button, Heading, Alert } from '@indeed/ifl-components';
import { CheckCircle } from '@indeed/ifl-icons';
import PageTransition from '../../../components/PageTransition/PageTransition';
import { Success } from '../../../components/Illustrations';

const LightApplyPostApplyPage: React.FunctionComponent = () => {
    // TODO: In a real implementation, get user email from URL params or Apollo state
    // For now, use a generic message since the application is complete
    const userEmail = 'ご登録のメールアドレス';

    const handleViewOtherJobs = () => {
        // Navigate to job search or dashboard
        window.location.href = 'https://jp.indeed.com';
    };

    return (
        <PageTransition pageKey="light-apply-post-apply">
            <Helmet>
                <title>応募が完了しました！ - Indeed</title>
                <meta
                    name="description"
                    content="応募が完了しました。確認メールをお送りいたします。"
                />
                <meta name="keywords" content="応募完了, 求人応募, Indeed, 成功" />
            </Helmet>

            <Box sx={{ inlineSize: '100%' }}>
                {/* Success Illustration */}
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginBlock: 6,
                    }}
                >
                    <Success
                        sx={{
                            inlineSize: '200px',
                            maxInlineSize: '100%',
                        }}
                        title="応募完了"
                        label="応募完了のイラスト"
                    />
                </Box>

                {/* Success Title */}
                <Box sx={{ marginBlockEnd: 4 }}>
                    <Heading
                        level={1}
                        sx={{
                            fontSize: '24px',
                            fontWeight: 'bold',
                            textAlign: 'center',
                            marginBlockEnd: 0,
                        }}
                    >
                        応募が完了しました！
                    </Heading>
                </Box>

                {/* Email Confirmation */}
                <Box sx={{ marginBlockEnd: 5 }}>
                    <Alert
                        status="info"
                        icon={<CheckCircle sx={{ color: 'foreground.status.success' }} />}
                        sx={{
                            backgroundColor: 'transparent',
                            border: '1px solid',
                            borderColor: 'border.action.weak',
                        }}
                    >
                        {userEmail} に確認メールが届きます
                    </Alert>
                </Box>

                {/* Action Buttons */}
                <Box sx={{ marginBlockEnd: 5 }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                        <Button variant="secondary" onClick={handleViewOtherJobs}>
                            求人検索に戻る
                        </Button>
                    </Box>
                </Box>
            </Box>
        </PageTransition>
    );
};

export default LightApplyPostApplyPage;
